import Cookie from 'vue-cookie'
import axios from 'axios'

// Initial state
const state = {
  userName: '',
  fullName: '',
  temporaryPassword: false,
  token: '',
  roles: [],
  connected: false,
  adminToken: '',
  impersonating: false,
  activeProduction: null,
  archivedProduction: null
}

// Mutations
const mutations = {
  loggedIn (state, userContext) {
    // console.log('Logged in with user name \'' + userContext.userName + '\'')
    state.userName = userContext.userName
    state.fullName = userContext.fullName
    state.temporaryPassword = userContext.temporaryPassword
    state.roles = userContext.roles
    state.token = userContext.token
    state.connected = true
    state.impersonating = false
    state.activeProduction = null
    state.archivedProduction = null
  },
  loggedOut (state) {
    // console.log('Logged out')
    state.userName = ''
    state.fullName = ''
    state.temporaryPassword = false
    state.roles = []
    state.token = ''
    state.connected = false
    state.impersonating = false
    state.activeProduction = null
    state.archivedProduction = null
  },
  startImpersonate (state, userContext) {
    state.adminToken = state.token
    state.impersonating = true
    state.userName = userContext.userName
    state.fullName = userContext.fullName
    state.temporaryPassword = false
    state.roles = userContext.roles
    state.token = userContext.token
    state.connected = true
  },
  endImpersonate (state, userContext) {
    state.adminToken = ''
    state.impersonating = false
    state.userName = userContext.userName
    state.fullName = userContext.fullName
    state.temporaryPassword = false
    state.roles = userContext.roles
    state.token = userContext.token
    state.connected = true
  },
  setConnected (state, connected) {
    state.connected = connected
  },
  setArchivedProduction (state, production) {
    state.archivedProduction = production
  },
  setActiveProduction (state, production) {
    state.activeProduction = production
  }
}

// Actions
const actions = {
  initialize ({ commit, state }) {
    // console.log('Initialize session')
    let userContextCookie = Cookie.get('USER_CONTEXT')
    if (userContextCookie) {
      let userContext = JSON.parse(userContextCookie)
      if (userContext && userContext.token && userContext.token.length > 0) {
        commit('loggedIn', userContext)
        // console.log('Set bearer token in Axios: ' + userContext.token)
        axios.defaults.headers.common = {'Authorization': 'Bearer ' + userContext.token}
      }
    }
  },
  login ({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      // console.log('Login with user name ' + ctx.userName)
      // Call the backend
      axios.post('/backend/rest/session/login', ctx)
        .then(response => {
          let userContext = response.data
          if (userContext) {
            Cookie.set('USER_CONTEXT', JSON.stringify(userContext))

            commit('loggedIn', userContext)

            axios.defaults.headers.common = {'Authorization': 'Bearer ' + userContext.token}

            localStorage.setItem('SessionToken', userContext.token)

            resolve('Successfully logged in')
          } else {
            console.log('Unknown error during login')
            let errorMessage = 'Unknown error occurred during login'
            reject(Error(errorMessage))
          }
        })
        .catch(error => {
          console.log('Login error: ' + JSON.stringify(error))
          let errorMessage = ''
          if (error.response.data.message && error.response.data.message !== '') {
            errorMessage = error.response.data.message
          // } else if (error.response.data && error.response.data !== '') {
          //  errorMessage = error.response.data
          } else {
            errorMessage = 'Unknown error occurred during login'
          }
          reject(Error(errorMessage))
        })
    })
  },
  tokenLogin ({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      // console.log('Re-using session from token ' + ctx.token)

      // Call the backend
      axios.post('/backend/rest/session/tokenLogin', ctx)
        .then(response => {
          let userContext = response.data

          Cookie.set('USER_CONTEXT', JSON.stringify(userContext))

          commit('loggedIn', userContext)

          axios.defaults.headers.common = {'Authorization': 'Bearer ' + userContext.token}

          localStorage.setItem('SessionToken', userContext.token)

          resolve('Successfully logged in with token')
        })
        .catch(error => {
          console.log('Login error: ' + JSON.stringify(error))
          let errorMessage = ''
          if (error.response.data.message && error.response.data.message !== '') {
            errorMessage = error.response.data.message
            // } else if (error.response.data && error.response.data !== '') {
            //  errorMessage = error.response.data
          } else {
            errorMessage = 'Unknown error occurred during login'
          }
          reject(Error(errorMessage))
        })
    })
  },
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      Cookie.delete('USER_CONTEXT')

      // Call the backend
      axios.post('/backend/rest/session/logout')
        .then(response => {
          localStorage.removeItem('SessionToken')
          axios.defaults.headers.common = {}
          resolve('Successfully logged out')
        })
        .catch(error => {
          console.log('Logout error: ' + JSON.stringify(error))
          let errorMessage = ''
          if (error.response.data.message && error.response.data.message !== '') {
            errorMessage = error.response.data.message
          } else {
            errorMessage = 'Unknown error occurred during logout'
          }
          axios.defaults.headers.common = {}
          reject(Error(errorMessage))
        })

      commit('loggedOut')
    })
  },
  impersonate ({ commit, state }, user) {
    return new Promise((resolve, reject) => {
      // console.log('Impersonate user ' + user.userName)
      axios.post('/backend/rest/session/impersonate/user/' + user.id)
        .then(response => {
          // console.log('Got response: ' + JSON.stringify(response))
          let userContext = response.data

          Cookie.set('USER_CONTEXT', JSON.stringify(userContext))

          commit('startImpersonate', userContext)

          axios.defaults.headers.common = {'Authorization': 'Bearer ' + userContext.token}

          resolve('Success')
        })
        .catch(error => {
          reject(Error(error.response.data.message))
        })
    })
  },
  endImpersonation ({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios.post('/backend/rest/session/logout')
        .then(response => {
          axios.post('/backend/rest/session/tokenLogin', { token: state.adminToken })
            .then(response => {
              let userContext = response.data

              Cookie.set('USER_CONTEXT', JSON.stringify(userContext))

              commit('endImpersonate', userContext)

              axios.defaults.headers.common = {'Authorization': 'Bearer ' + userContext.token}

              resolve('Stopped impersonation')
            })
            .catch(error => {
              let errorMessage = ''
              if (error.response.data.message && error.response.data.message !== '') {
                errorMessage = error.response.data.message
              } else {
                errorMessage = 'Unknown error occurred'
              }
              reject(Error(errorMessage))
            })
        })
        .catch(error => {
          console.log('Logout error: ' + JSON.stringify(error))
          let errorMessage = ''
          if (error.response.data.message && error.response.data.message !== '') {
            errorMessage = error.response.data.message
          } else {
            errorMessage = 'Unknown error occurred during logout'
          }
          reject(Error(errorMessage))
        })
    })
  },
  setConnected ({ commit, state }, connected) {
    commit('setConnected', connected)
  },
  startArchivedProduction ({ commit, state }, production) {
    commit('setArchivedProduction', production)
  },
  stopArchivedProduction ({ commit, state }) {
    commit('setArchivedProduction', null)
  },
  setArchivedProduction ({ commit, state }, production) {
    commit('setArchivedProduction', production)
  },
  setActiveProduction ({ commit, state }, production) {
    commit('setActiveProduction', production)
  }
}

// Getters
const getters = {
  hasRole: (state) => (role) => {
    let res = state.roles && Array.isArray(state.roles) && (state.roles.includes('ADMINISTRATOR') || state.roles.includes(role))
    // console.log('Has ' + role + ': ' + res)
    return res
  },
  hasAdministratorRole: (state) => {
    return state.roles && state.roles.includes('ADMINISTRATOR')
  },
  isConnected: (state) => {
    return state.connected
  },
  hasToken: (state) => {
    return state.token !== ''
  },
  isImpersonating: (state) => {
    return state.impersonating
  },
  hasArchivedProduction: (state) => {
    return state.archivedProduction != null
  },
  getArchivedProduction: (state) => {
    return state.archivedProduction
  },
  hasActiveProduction: (state) => {
    return state.activeProduction != null
  },
  getActiveProduction: (state) => {
    return state.activeProduction
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/session.js